import type {NoteWritebackActions} from 'src/types/note-writeback-metadata';
import type {NoteWritebackMetadataAction} from 'src/action-creators/note-writeback-metadata';

import {NoteWritebackMetadataReceive} from 'src/action-creators/note-writeback-metadata';


export type State = {
  actions: NoteWritebackActions;
};

const initialState = {
  actions: [],
} as const;

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly actions: readonly []; }' is not assignable to type 'State'.
  state: State | null | undefined = initialState,
  action: NoteWritebackMetadataAction,
): State => {
  switch (action.type) {
    case NoteWritebackMetadataReceive: {
      return {
        ...state,
        actions: action.payload,
      };
    }
  }

  // @ts-expect-error - TS2322 - Type 'State | null' is not assignable to type 'State'.
  return state;
};
